module.exports = __webpack_public_path__ + "img/menu_schedule_icon.c961ff98.svg";